var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-sans text-base flex-col flex h-screen bg-background "},[_c('div',{staticClass:"flex flex-row flex-grow h-16"},[_c('div',{staticClass:"flex-grow w-16 h-full"},[_c('Nuxt')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }